import Axios from 'axios';
export const axiosTemplate = (token, cancelToken, headers = {}, abortSignal) => {
    return Axios.create({
        signal: abortSignal,
        headers: {
            Authorization: `Bearer ${token}`,
            ...headers,
        },
        cancelToken,
    });
};
